/*
 * Copyright (c) 2025 metromorph softworks GmbH
 *
 * All rights reserved
 */

import { ThemeOptions } from "@mui/material/styles";
import { gridThemeOptions } from "@ef/components-grid/theme";


export default {
    ...gridThemeOptions,
} as ThemeOptions;
